import type { RouterOptions } from ".";

export const routes = [
	{
		path: "/",
		name: "home",
		component: () => import("@client/pages/Home.vue"),
		meta: { sidebar: false },
	},
	{
		path: "/login",
		component: () => import("@client/pages/Login.vue"),
		name: "login",
		meta: { layout: "Blank" },
	},
	{
		path: "/Register",
		component: () => import("@client/pages/Register.vue"),
		name: "register",
		meta: { layout: "Blank" },
	},
	{
		path: "",
		component: () => import("@client/pages/Lobby.vue"),
		name: "lobby",
	},
	{
		path: "",
		component: () => import("@client/pages/Matchmaking"),
		name: "matchmaking",
	},
	{
		path: "",
		component: () => import("@client/pages/OpponentSelection"),
		name: "opponent-selection",
	},
	{
		path: "",
		component: () => import("@client/pages/Exam"),
		name: "exam",
		meta: { layout: "Blank" },
	},
	{
		path: "",
		component: () => import("@client/pages/Leaderboard"),
		name: "leaderboard",
		meta: { sidebar: false },
	},
	{
		path: "",
		component: () => import("@client/pages/Profile"),
		name: "profile",
	},
	{
		path: "",
		component: () => import("@client/pages/CategoriesSelection"),
		name: "categories",
		meta: { layout: "Selection" },
	},
	{
		path: "",
		component: () => import("@client/pages/Review"),
		name: "review",
	},
] as RouterOptions["routes"];
